import {
  RichTextEditorProps,
  RichTextViewer as RichTextViewerComponent,
  RichTextViewerProps,
  RichTextEditor as RichTextEditorComponent,
} from "widgets";

export function RichTextViewer(props: Omit<RichTextViewerProps, "fontMap">) {
  return (
    <RichTextViewerComponent
      fontMap={{
        "Inter-Regular":
          "https://rsms.me/inter/font-files/Inter-Regular.woff2?v=4.0",
        "Inter-Bold":
          "https://rsms.me/inter/font-files/Inter-SemiBold.woff2?v=4.0",
        "Inter-Italic":
          "https://rsms.me/inter/font-files/Inter-Italic.woff2?v=4.0",
        "Inter-SemiBoldItalic":
          "https://rsms.me/inter/font-files/Inter-SemiBoldItalic.woff2?v=4.0",
      }}
      {...props}
    />
  );
}

function RichTextEditor(props: Omit<RichTextEditorProps, "fontMap">) {
  return (
    <RichTextEditorComponent
      fontMap={{
        "Inter-Regular":
          "https://rsms.me/inter/font-files/Inter-Regular.woff2?v=4.0",
        "Inter-Bold":
          "https://rsms.me/inter/font-files/Inter-SemiBold.woff2?v=4.0",
        "Inter-Italic":
          "https://rsms.me/inter/font-files/Inter-Italic.woff2?v=4.0",
        "Inter-SemiBoldItalic":
          "https://rsms.me/inter/font-files/Inter-SemiBoldItalic.woff2?v=4.0",
      }}
      {...props}
    />
  );
}
